import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Namn")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Matchtyp")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Spelare ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Namn")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Klubb")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Skapa ")
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Spara")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_select_option = _resolveComponent("ion-select-option")
  const _component_ion_select = _resolveComponent("ion-select")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_list_header = _resolveComponent("ion-list-header")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_chip = _resolveComponent("ion-chip")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_base_layout = _resolveComponent("base-layout")

  return (_openBlock(), _createBlock(_component_base_layout, {
    "page-title": "Skapa pool",
    "page-default-back-link": "/home"
  }, {
    default: _withCtx(() => [
      _createVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "floating" }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_select, {
                  placeholder: "Välj",
                  interface: "popover",
                  modelValue: _ctx.matchType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.matchType = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.matchTypes, (type) => {
                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                        key: type.value,
                        value: type.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(type.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_list_header, null, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode("div", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.players, (player) => {
                return (_openBlock(), _createBlock(_component_ion_chip, {
                  key: player.id,
                  onClick: ($event: any) => (_ctx.removePlayer(player.id))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(player.name) + " - " + _toDisplayString(player.club), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_icon, { name: "close" })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "floating" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.playerName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.playerName = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "floating" }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.playerClub,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.playerClub = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              onClick: _ctx.addPlayer,
              type: "button",
              disabled: !(_ctx.playerName && _ctx.playerClub)
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_ion_button, {
              expand: "block",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }))
}